import { getWorkFlowTasksSchedule, getWorkflowPassData } from '@/api/workFlow'
import { getTemplateAttribute } from '@/api/preview'
import Schedule from '@/views/WorkFlow/components/Schedule'
import ReportEditor from '@/views/Report/ReportEditor/index.vue'
import FormEditor from '@/views/Report/FormEditor/index.vue'
export default {
  data() {
    return {
      taskId: '',
      defaultValue: '',
      currentRow: undefined,
      instanceId: '',
      unfinished: [],
      workFlowId: 0,
      maximization: true,
      popoverVisible: false,
      popoverLoading: false,
      checkVisible: false,
      scheduleList: [],
      scheduleVisible: false,
      scheduleLoading: false,
      maxWidth: '100',
      viewHost: 0
    }
  },
  components: {
    Schedule,
    ReportEditor,
    FormEditor
  },
  watch: {
    scheduleVisible(newVal) {
      if (newVal) {
        document.onkeyup = e => {
          if (e.keyCode === 27) {
            this.scheduleVisible = false
            this.scheduleLoading = false
            this.checkVisible = false
          }
        }
      } else {
        document.onkeyup = null
      }
    },
    checkVisible(newVal) {
      if (newVal && this.state === 'check') {
        document.onkeyup = e => {
          if (e.keyCode === 27) {
            this.checkVisible = false
          }
        }
      } else {
        document.onkeyup = null
      }
    },
    maximization(newVal) {
      const w = document.body.clientWidth
      this.maxWidth = newVal ? w - 264 : '50'
      if (!this.viewHost) {
        this.$nextTick(() => {
          if (this.transactVisible) {
            setTimeout(() => {
              this.$refs.transactReportEditor.spreadSheet.resize()
            }, 300)
          } else {
            setTimeout(() => {
              this.$refs.reportEditor.spreadSheet.resize()
            }, 300)
          }
        })
      }
    }
  },
  mounted() {
    const w = document.body.clientWidth
    this.maxWidth = w - 264
  },
  methods: {
    handleMaximization() {
      this.maximization = !this.maximization
    },
    // 查看
    handleCheck(row, type) {
      this.currentType = type
      console.log(row)
      if (row.templateId === 0 || row.recordId === 0) {
        this.$message.error('当前流程没有头部节点，无法打开表单！')
        return
      }
      this.maximization = true
      this.workFlowId = row.workFlowId
      this.state = 'check'
      this.currentRow = row
      this.checkVisible = true
      this.popoverLoading = true
      this.$nextTick(() => {
        this.getTemplateInfo(row.templateId).then(() => {
          this.$refs.reportEditor.InitializeReport(row, 2).then(() => {
            this.popoverLoading = false
          })
        })
      })
    },
    // 查看进度
    handleSchedule(row) {
      console.log(row)
      this.currentRow = row
      this.workFlowId = row.workFlowId
      this.scheduleLoading = true
      this.scheduleVisible = true
      getWorkFlowTasksSchedule(row.id).then(res => {
        this.instanceId = res.data.instanceId
        this.unfinished = res.data.unfinished
        this.scheduleList = res.data.schedule
        this.scheduleLoading = false
      })
    },
    getTemplateInfo(tid) {
      return new Promise((resolve, reject) => {
        getTemplateAttribute(tid).then(res => {
          this.viewHost = res.data.viewHost
          resolve()
        })
      })
    }
  }
}
